module.exports = __webpack_public_path__ + "img/success-register.56b53661.svg";